import React, { useState } from "react";
import { Link } from "react-router-dom";
/**
 * Video data — matches the Figma spec.
 * All three cards show "CloseCarbon Basic Plan" / "5 mins" as per the design export.
 * Replace `thumbnail` with your real image paths (e.g. `import thumb1 from "../../images/..."`).
 */
const videos = [
  {
    id: 1,
    title: "CloseCarbon Basic Plan",
    duration: "5 mins",
    videoId: "FbmkfkwIq6c",
    thumbnail: "https://img.youtube.com/vi/FbmkfkwIq6c/hqdefault.jpg",
    overlayOpacity: "0.69", // Featured card — darker overlay
  },
  {
    id: 2,
    title: "Netzence Innovation Centre",
    duration: "5 mins",
    videoId: "E-nAeZAXiV8",
    thumbnail: "https://img.youtube.com/vi/E-nAeZAXiV8/hqdefault.jpg",
    overlayOpacity: "0.28",
  },
  {
    id: 3,
    title: "CloseCarbon Basic Plan",
    duration: "5 mins",
    videoId: "ppPfMr0nerY",
    thumbnail: "https://img.youtube.com/vi/ppPfMr0nerY/hqdefault.jpg",
    overlayOpacity: "0.28",
  },
];

function VideoCard({ title, duration, videoId, thumbnail, overlayOpacity }) {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className="flex flex-col bg-[#FAFAFA] rounded-xl overflow-hidden transition-shadow duration-200  cursor-pointer group">
      {/* Thumbnail (384 × 327 at full width) */}
      <div className="relative w-full aspect-[384/327] overflow-hidden bg-gray-200">
        {isPlaying ? (
          <iframe
            className="absolute inset-0 h-full w-full border-0"
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
            title={title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        ) : (
          <>
            <img
              src={thumbnail}
              alt={title}
              className="absolute inset-0 h-full w-full object-cover"
              loading="lazy"
            />
            <div
              className="absolute inset-0"
              style={{ backgroundColor: `rgba(0, 0, 0, ${overlayOpacity})` }}
            />
            <button
              type="button"
              onClick={() => setIsPlaying(true)}
              aria-label={`Play ${title}`}
              className="absolute top-1/2 left-1/2 flex h-[54px] w-[54px] -translate-x-1/2 -translate-y-1/2 items-center justify-center transition-transform duration-200  focus:outline-none focus:ring-2 focus:ring-white rounded-full"
            >
              <svg
                width="54"
                height="54"
                viewBox="0 0 54 54"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 15L38 27L20 39V15Z"
                  fill="#FFFFFF"
                  stroke="#FFFFFF"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </>
        )}
      </div>

      {/* Text content (p-5, gap-4 → 104px total) */}
      <div className="flex flex-col gap-4 p-5">
        <h3 className="text-[20px] lg:text-[24px] font-medium leading-[29px] text-[#141414]">
          {title}
        </h3>
        <p className="text-[16px] font-medium leading-[19px] text-[#898989]">
          {duration}
        </p>
      </div>
    </div>
  );
}

function WatchCloseCarbon() {
  return (
    <section className="w-full bg-white px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 py-12 sm:py-16 lg:py-20 xl:py-[120px]">
      <div className="w-full max-w-[1200px] mx-auto flex flex-col gap-8 lg:gap-12">
        {/* Header row — heading + subtitle on left, CTA on right */}
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 md:gap-10">
          <div className="flex flex-col gap-4 text-center md:text-left flex-1">
            <h2 className="text-[40px] sm:text-3xl mb-4 md:text-4xl lg:text-[40px] font-bold leading-[120%] tracking-[-0.04em] text-[#3B3B3B]">
              Watch CloseCarbon
            </h2>
            <p
              className="text-base lg:text-[18px] leading-[145%] text-[#3B3B3B]"
              style={{
                fontFamily: "'Inter', sans-serif",
                fontFeatureSettings:
                  "'salt' on, 'cv01' on, 'cv03' on, 'cv04' on",
              }}
            >
              Take a sneak peak of CloseCarbon!
            </p>
          </div>

          <Link
            to="/watch-more"
            type="button"
            className="flex items-center justify-center px-[18px] py-3 w-[156px] sm:w-auto sm:min-w-[156px] h-[56px] bg-white/80 border border-[#006633] rounded-xl hover:bg-[#006633]/5 transition-colors flex-shrink-0"
          >
            <span className="text-[16px] font-medium leading-[19px] text-[#006633]/80 whitespace-nowrap">
              See more
            </span>
          </Link>
        </div>

        {/* Video cards — 1 / 2 / 3 column layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {videos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default WatchCloseCarbon;
